import styled, {css} from 'styled-components'

import RunlabSelect, {SelectStyled as RunlabSelectStyled} from './select'

export const Select = styled(RunlabSelect)``

export const Control = styled.div<{$error: boolean}>`
  display: flex;
  align-items: center;

  border-style: solid;
  border-width: 1px;
  border-radius: 6px;
  border-color: ${props => (props.$error && props.theme.colors.error) || props.theme.colors.gray6};

  & * {
    transition: unset;
  }

  & ${RunlabSelectStyled} {
    .ant-select-selector {
      border: unset !important;
    }

    .ant-select-arrow {
      display: none !important;
    }

    .ant-select-selection-item,
    .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
      height: 100% !important;
      display: flex !important;
      padding: unset !important;
    }
  }

  input,
  .ant-input-outlined {
    border: unset;
    padding-left: unset;
  }
`

export const Wrapper = styled.div<{$disabled?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${props =>
    props.$disabled &&
    css`
      & ${Control} *:not(.img) {
        background: transparent !important;
      }

      & ${Control} {
        background: rgba(0, 0, 0, 0.04);
      }
    `}
`
